/** Angular Imports */
import { Component, OnInit } from '@angular/core';

/**
 * Self service component.
 *
 * All components related to self service admin portal are routed here.
 */
@Component({
  selector: 'mifosx-self-service',
  templateUrl: './self-service.component.html',
  styleUrls: ['./self-service.component.scss']
})
export class SelfServiceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
